export default __webpack_public_path__ + "static/media/PortraitCurtain.e2626ad2.svg";